import { create } from 'zustand';

interface Message {
  id: string;
  content: string;
  from: 'me' | 'peer';
  timestamp: number;
  encrypted?: boolean;
}

interface ChatState {
  messages: Message[];
  isConnected: boolean;
  peerConnected: boolean;
  roomStatus: 'waiting' | 'active' | 'closed';
  addMessage: (message: Omit<Message, 'id' | 'timestamp'>) => void;
  setConnected: (connected: boolean) => void;
  setPeerConnected: (connected: boolean) => void;
  setRoomStatus: (status: 'waiting' | 'active' | 'closed') => void;
  clearMessages: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  isConnected: false,
  peerConnected: false,
  roomStatus: 'waiting',
  
  addMessage: (message) => set((state) => ({
    messages: [...state.messages, {
      ...message,
      id: crypto.randomUUID(),
      timestamp: Date.now(),
    }],
  })),
  
  setConnected: (connected) => set({ isConnected: connected }),
  setPeerConnected: (connected) => set({ peerConnected: connected }),
  setRoomStatus: (status) => set({ roomStatus: status }),
  clearMessages: () => set({ messages: [] }),
}));

interface TradeState {
  orderId: string | null;
  role: 'maker' | 'taker' | null;
  status: 'matched' | 'escrow' | 'paid' | 'released' | 'disputed' | null;
  setOrder: (orderId: string, role: 'maker' | 'taker') => void;
  setStatus: (status: TradeState['status']) => void;
}

export const useTradeStore = create<TradeState>((set) => ({
  orderId: null,
  role: null,
  status: null,
  
  setOrder: (orderId, role) => set({ orderId, role }),
  setStatus: (status) => set({ status }),
}));
